import { b as U } from "./withEditable-7d0a220a.js";
import { jsx as o } from "react/jsx-runtime";
import { useCallback as S, useMemo as $, createElement as v } from "react";
import { DataList as c } from "@ucl/react-library/dataList";
import { Icon as d } from "@ucl/react-library/icon";
import "@adobe/aem-spa-page-model-manager";
import "html-react-parser";
import "sanitize-html";
import { s as z } from "./sanitizeProps-304c699d.js";
import { EditableButton as I, BUTTON_RESOURCE_TYPE as Y } from "./button.js";
import { EditableImage as A, IMAGE_RESOURCE_TYPE as G } from "./image.js";
import { EditableText as h, TEXT_RESOURCE_TYPE as k } from "./richTextEditor.js";
import { EditableTagGroup as x, TAG_GROUP_RESOURCE_TYPE as M } from "./tagGroup.js";
import "@adobe/aem-react-editable-components";
import "./PageContext-57b2437f.js";
import "./component-a7888ba1.js";
import "./EditableComponentUtils-0b5699b7.js";
import "@ucl/react-library/useIsMounted";
import "./ComponentContext-3bb2d205.js";
import "./withErrorBoundary.js";
import "@ucl/shared-component-foundations/foundations";
import "styled-components";
import "./index-0371017d.js";
import "@ucl/react-library/analytics";
import "@ucl/react-library/button";
import "@ucl/react-library/hooks_internal";
import "@ucl/react-library/image";
import "./useViewPortProps-0c0b5cc6.js";
import "@ucl/react-library/useMediaQuery";
import "./RichTextEditor-74d706e9.js";
import "./parseHTMLString-24a59cc8.js";
import "./sanitizeHtml-95395ce0.js";
import "@ucl/react-library";
const T = {
  button: {
    Component: I,
    resourceType: Y
  },
  image: {
    Component: A,
    resourceType: G
  },
  text: {
    Component: h,
    resourceType: k
  }
}, C = ({ listItems: e, cqPath: m, cqItems: p, ...R }) => {
  function u(t, i) {
    return `${f.split("/").at(-1)}_${t.split("/").at(-1)}_${i}`;
  }
  const s = S((t, i, r, n = "") => {
    if (t) {
      if (t === "icon")
        return /* @__PURE__ */ o(d, {
          icon: i,
          size: r
        });
      if (t in T) {
        const { Component: E, resourceType: l } = T[t];
        return /* @__PURE__ */ o(E, {
          name: u(l, n),
          disableResizable: !0,
          parentCqPath: m,
          parentCqItems: p
        });
      }
    }
  }, [
    m,
    p
  ]), _ = $(() => e.map(({ secondaryIconName: t, secondaryIconSize: i, eyebrowText: r, eyebrowIconName: n, eyebrowIconSize: E, enableTags: l, leadingElementName: b, leadingIconName: g, leadingIconSize: y, trailingElementName: L, trailingIconName: D, trailingIconSize: P, ...O }, a) => /* @__PURE__ */ v(c.Item, {
    secondaryIcon: t ? /* @__PURE__ */ o(d, {
      size: i,
      icon: t
    }) : void 0,
    eyebrowProps: r ? {
      eyebrowText: r,
      eyebrowIcon: n ? /* @__PURE__ */ o(d, {
        size: E,
        icon: n
      }) : void 0
    } : void 0,
    tagProps: l ? {
      _renderTags: () => /* @__PURE__ */ o(x, {
        name: u(M, a),
        disableResizable: !0,
        parentCqPath: m,
        parentCqItems: p
      })
    } : void 0,
    leadingElement: s(b, g, y, `${a}leading`),
    trailingElement: s(L, D, P, `${a}trailing`),
    ...O,
    key: a
  })), [
    e,
    m,
    p,
    s
  ]);
  return /* @__PURE__ */ o(c, {
    ...z(R),
    children: _
  });
};
C.displayName = "DataList";
const B = (e) => e.listItems.length === 0, f = "ucl/components/datalist", j = {
  emptyLabel: "Data List",
  isEmpty: B,
  resourceType: f
}, gt = U(j, C);
export {
  f as DATA_LIST_RESOURCE_TYPE,
  gt as EditableDataList
};
